export function isNumber(input?: string) {
  if (input === null || input === undefined) {
    return false;
  }

  return !isNaN(Number(input)) && input.length > 2;
}

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}